import { render, staticRenderFns } from "./AddSimcardsBatch.vue?vue&type=template&id=48d2bf04"
import script from "./AddSimcardsBatch.vue?vue&type=script&lang=js"
export * from "./AddSimcardsBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports